import type { Tenant } from "../types/auth";

export function storedTenant(): Tenant | null {
  const value = localStorage.getItem("tenant") ?? localStorage.getItem("business");
  if (!value) return null;

  try {
    const tenant = JSON.parse(value) as Tenant;
    localStorage.setItem("tenant", JSON.stringify(tenant));
    localStorage.removeItem("business");
    return tenant;
  } catch {
    return null;
  }
}
